import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=94a8385c&scoped=true&"
import script from "./NotesDialog.vue?vue&type=script&lang=js&"
export * from "./NotesDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotesDialog.vue?vue&type=style&index=0&id=94a8385c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a8385c",
  null
  
)

export default component.exports